import { Panel } from "@poseidon/ui/components";
import React from "react";
import { FileManagementDealer } from "./FileManagementDealer";

export const DealerInvoiceActionSection = ({ application }) => {
  return (
    <Panel title="Invoices">
      <FileManagementDealer
        application={application}
        fileCategory="application"
        fileGroup="invoices"
      />
    </Panel>
  );
};
